import { ExternalLookupType } from '@/typings';
import { config } from '../config';
import type { FormFieldWarning } from '../typings';

/** The longest typed facility name the server accepts (`ExternalLookupUpdateService.FacilityNameMaxLength`). */
export const FACILITY_NAME_MAX_LENGTH = 255;

/** The warning under a facility field that holds a name the provider typed instead of picked. */
export const FACILITY_FREE_TEXT_WARNING: FormFieldWarning = {
  title: 'Staff Verification May Delay Credentialing',
  description:
    "This facility isn't in our registry, so our staff will verify it before your credentialing can be completed. If your facility appears in the suggestions, select it instead.",
};

/** The default hint of a facility typeahead, which keeps typed text. */
export const FACILITY_TYPEAHEAD_HINT =
  "Start typing and select a facility from the list, or type its full name if it isn't listed.";

/** True for the external lookup options of a Facility lookup. */
export const isFacilityLookup = (options?: {
  lookupType?: ExternalLookupType;
}): boolean => options?.lookupType === ExternalLookupType.Facility;

/** True when a facility field holds a typed name: not a pick, and not the registry name the server holds. */
export const holdsFacilityFreeText = (
  value: unknown,
  registryName: string | null | undefined,
): boolean => {
  if (typeof value !== 'string') return false;
  const text = value.trim();
  return (
    text !== '' &&
    !text.startsWith(config.externalLookupPrefix) &&
    text !== registryName?.trim()
  );
};
